"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.englishTranslations = void 0;
var _types = require("../../../types");
const englishTranslations = exports.englishTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'So sorry!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Back',
  [_types.ErrorPageTranslationKey.text]: 'This page is out of order for the moment',
  [_types.ErrorPageTranslationKey.notFound]: 'The page you are looking for is not available',
  [_types.ErrorPageTranslationKey.unauthorized]: 'The page you are trying to reach is restricted and not all criteria was met.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Please contact Oriflame support team by email:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'The requested URL was rejected!'
};
